// src/constants/routes.ts

// Get the route prefix from environment variables, defaulting to an empty string if not set
const ROUTE_PREFIX = process.env.REACT_APP_ROUTE_PREFIX || "";

// Define your routes as constants using the prefix
export const ROUTES = {
	HOME: `${ROUTE_PREFIX}/`,
	MAIN: `${ROUTE_PREFIX}/home`,
	TERMS: `${ROUTE_PREFIX}/terms`,
	TERMS_DETAIL: `${ROUTE_PREFIX}/terms/:slug`,
	ACCOUNT: `${ROUTE_PREFIX}/account`,
	CARGO_SEARCH: `${ROUTE_PREFIX}/cargo-search`,
	TRANSPORT_SEARCH: `${ROUTE_PREFIX}/transport-search`,
	MY_OFFERS: `${ROUTE_PREFIX}/my-offers`,
	MY_REQUESTS: `${ROUTE_PREFIX}/my-requests`,
	MY_BIDS: `${ROUTE_PREFIX}/my-bids`,
	DELIVERIES: `${ROUTE_PREFIX}/deliveries`,
	CHAT: `${ROUTE_PREFIX}/chat`,
	NEWS: `${ROUTE_PREFIX}/news`,
	NEWS_DETAIL: `${ROUTE_PREFIX}/news/:id`,
	HOW_TO_USE: `${ROUTE_PREFIX}/how-to-use`,
	// Add more routes as needed
} as const;

// Define a list of route paths for easier iteration or use in guards, etc.
export const ROUTE_PATHS = Object.values(ROUTES);
